import { useGet } from '../../../sharedModules/hooks/useQuery';
import { DepartmentGroupWithMembers } from '../model';

const URL = '/collections/department_group_memberships';

export function departmentGroupMembershipsUrl() {
  return URL;
}

export function useDepartmentGroupMemberships(location: string) {
  return useGet<DepartmentGroupWithMembers[]>({ url: URL, params: { location } });
}
